<ng-container>
    <div class="graph-grid">
<!--        TODO missing temperature -->
<!--        <div class="fr-4 line-between-rows"></div>-->

<!--        <div class="measurement-title">{{ 'person.dashboard.temperature' | translate }}</div>-->
<!--        <div class="measurement-value">36,7 °C</div>-->
<!--        <div>-->
<!--            <p-chart type="line" [data]="lineGraphData" [options]="lineGraphOptions"></p-chart>-->
<!--        </div>-->

        <div class="fr-4 line-between-rows"></div>

        <div class="measurement-title">{{ 'person.dashboard.bloodPressure' | translate }}</div>
        <div class="measurement-value">
            {{ generateValues('systolicPressure').slice(-1)[0] }}/{{ generateValues('diastolicPressure').slice(-1)[0] }}
        </div>
        <div>
            <p-chart type="line" [data]="pressureGraphData()" [options]="lineGraphOptions"></p-chart>
        </div>

        <div class="fr-4 line-between-rows"></div>

        <div class="measurement-title">{{ 'person.dashboard.glycemia' | translate }}</div>
        <div class="measurement-value">
            {{ generateValues('glycemia').slice(-1)[0] }}
        </div>
        <div>
            <p-chart type="line" [data]="glycemiaGraphData()" [options]="lineGraphOptions"></p-chart>
        </div>

        <div class="fr-4 line-between-rows"></div>

        <div class="measurement-title">{{ 'person.dashboard.weight' | translate }}</div>
        <div class="measurement-value">{{ generateValues('weight').slice(-1)[0] }} kg</div>
        <div>
            <p-chart type="line" [data]="weightGraphData()" [options]="lineGraphOptions"></p-chart>
        </div>

        <div class="fr-4 line-between-rows"></div>

        <div class="measurement-title">{{ 'person.dashboard.pain' | translate }}</div>
        <div class="measurement-value">
            {{ generateValues('pain').slice(-1)[0] }}
        </div>
        <div>
            <p-chart type="line" [data]="painGraphData()" [options]="lineGraphOptions"></p-chart>
        </div>

        <div class="fr-4 line-between-rows"></div>

        <div class="measurement-title">{{ 'person.dashboard.pulse' | translate }}</div>
        <div class="measurement-value">
            {{ generateValues('pulse').slice(-1)[0] }}
        </div>
        <div>
            <p-chart type="line" [data]="pulseGraphData()" [options]="lineGraphOptions"></p-chart>
        </div>

        <div class="fr-4 line-between-rows"></div>

        <div class="measurement-title">{{ 'person.dashboard.breath' | translate }}</div>
        <div class="measurement-value">
            {{ generateValues('breath').slice(-1)[0] }}
        </div>
        <div>
            <p-chart type="line" [data]="breathGraphData()" [options]="lineGraphOptions"></p-chart>
        </div>

        <div class="fr-4 line-between-rows"></div>

        <div class="measurement-title">{{ 'person.dashboard.spo2' | translate }}</div>
        <div class="measurement-value">
            {{ generateValues('spo2').slice(-1)[0] }} %
        </div>
        <div>
            <p-chart type="line" [data]="spo2GraphData()" [options]="lineGraphOptions"></p-chart>
        </div>

        <div class="fr-4 line-between-rows"></div>
    </div>
</ng-container>